export default __webpack_public_path__ + "static/assets/4dceca5b04bb0a456575065d42ce9fd3.png";